import React, { useState, useCallback } from "react";
// External dependencies

// Internal Dependencies
import quickLinksArray from "../../../data/arrays/quickLinksArray";
import { handleDropdownClick } from "../../../utils/functions/handleDropdownClick";

const QuickLinksMenu = ({ isOpen, setDropdownState, toggleQuickLinkMenu }) => {
  const [first, setfirst] = useState(false);
  const hideShowSubMenu = () => {
    setfirst(!first);
  };
  return (
    <>
      {isOpen && !toggleQuickLinkMenu && (
        <div
          className="header-overlay"
          onClick={() => handleDropdownClick("isOpen", setDropdownState)}
          onContextMenu={() => handleDropdownClick("isOpen", setDropdownState)}
        ></div>
      )}
      <li
        className={`m-menu__item  m-menu__item--submenu m-menu__item--rel ${
          isOpen && "m-menu__item--open-dropdown m-menu__item--hover"
        }`}
        m-menu-submenu-toggle="click"
        m-menu-link-redirect="1"
        aria-haspopup="true"
      >
        <span
          className="m-menu__link m-menu__toggle"
          onClick={() => handleDropdownClick("isOpen", setDropdownState)}
        >
          <i className="m-menu__link-icon fa fa-plus-square-o"></i>
          <span className="m-menu__link-text" style={{ color: "#fff" }}>
            Quick Action
          </span>
          <i className="m-menu__hor-arrow fa fa-angle-down"></i>
          <i className="m-menu__ver-arrow fa fa-angle-right"></i>
        </span>
        <div
          className="m-menu__submenu  m-menu__submenu--fixed m-menu__submenu--left"
          style={{ width: "1000px", display: isOpen ? "block" : "none" }}
        >
          <div className="m-menu__subnav">
            <ul className="m-menu__content">
              {quickLinksArray?.map((quickMenu, index) => (
                <li
                  key={index}
                  className="m-menu__item"
                  onClick={() => hideShowSubMenu()}
                >
                  <h3 className="m-menu__heading m-menu__toggle">
                    <span className="m-menu__link-text">
                      {quickMenu.menuTitle}
                    </span>
                    <i className="m-menu__ver-arrow fa fa-angle-right"></i>
                  </h3>
                  {quickMenu.submenu.length > 0 && (
                    <ul
                      className="m-menu__inner"
                      style={{
                        display: first && "block",
                        overflow: first && "auto",
                      }}
                    >
                      {quickMenu.submenu.map((quickSubMenu, subIndex) => (
                        <li
                          key={subIndex}
                          className="m-menu__item"
                          m-menu-link-redirect="1"
                          aria-haspopup="true"
                        >
                          <a href={quickSubMenu.url} className="m-menu__link">
                            <i className="m-menu__link-bullet m-menu__link-bullet--line">
                              <span></span>
                            </i>
                            <span className="m-menu__link-text">
                              {quickSubMenu.submenuTitle}
                            </span>
                          </a>
                        </li>
                      ))}
                    </ul>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </li>
    </>
  );
};

export default QuickLinksMenu;
